// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"b0cef7cc","209":"a40e946a","239":"80baf8d0","350":"6ec619ba","389":"a61b6b62","453":"38ead990","455":"5cdad5c0","591":"12169f3d","636":"8721f0b7","673":"679cdc5e","748":"62cc655a","854":"49b6b312","887":"9af521bc","929":"5c4a5c47","977":"6cf6b793"}[chunkId] + ".chunk.js";
};